import React from 'react';
import { useParams } from 'react-router-dom';
import { CheckoutPreview as Preview } from '../components/Checkout/CheckoutPreview';
import { useCheckoutStore } from '../store/checkoutStore';
import { useProductStore } from '../store/productStore';

export const CheckoutPreview = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);
  const { getPublishedPage } = useCheckoutStore();
  const getProduct = useProductStore((state) => state.getProduct);

  // Get the checkout page and ensure it exists and is active
  const checkoutPage = id ? getPublishedPage(id) : null;
  const isPageAccessible = checkoutPage && (checkoutPage.active && !checkoutPage.archived);
  const product = checkoutPage?.productId ? getProduct(checkoutPage.productId) : null;

  React.useEffect(() => {
    const loadCheckoutData = async () => {
      try {
        setIsLoading(true);
        // Simulate API call delay
        await new Promise(resolve => setTimeout(resolve, 500));
        setIsLoading(false);
      } catch (err) {
        setError('Failed to load checkout page');
        setIsLoading(false);
      }
    };

    loadCheckoutData();
  }, [id]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#1E293B] border-t-transparent"></div>
      </div>
    );
  }

  if (error || !isPageAccessible || !product) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white p-8 rounded-lg shadow-sm text-center max-w-md w-full">
          <h1 className="text-xl font-semibold text-gray-900 mb-2">
            {error || "Checkout Page Not Found"}
          </h1>
          <p className="text-gray-500">
            The checkout page you're looking for doesn't exist, has been deactivated, or has been removed.
          </p>
        </div>
      </div>
    );
  }

  const settings = {
    heading: checkoutPage.displayName || product.name,
    features: [
      'All features included in basic plan',
      'Easy and flexible business management',
      'Full time customer support',
      '20 TB cloud storage'
    ],
    buttonText: 'Make payment',
    primaryColor: checkoutPage.theme.primaryColor,
    logo: checkoutPage.theme.logo,
    showCouponOption: checkoutPage.showCouponOption
  };

  return <Preview settings={settings} />;
};